import type {EnrichedIssueListItem, IssueLinkedPullRequestSummary} from '../types/list-types'

export type GetIssueReferenceParams = {
  isAccountIssue: boolean
  issue: Pick<EnrichedIssueListItem, 'number' | 'repoNameWithOwner'>
  ownerLogin: string
  showRepository: boolean
}

function getPermalinkPathname(permalink: string): string | undefined {
  if (permalink.startsWith('/')) return permalink

  const isHttpUrl = permalink.startsWith('http://') || permalink.startsWith('https://')
  if (!isHttpUrl) return undefined

  const authorityStart = permalink.indexOf('://') + 3
  const pathnameStart = permalink.indexOf('/', authorityStart)
  return pathnameStart === -1 ? undefined : permalink.slice(pathnameStart)
}

export function isAccountIssuePermalink(permalink: string, ownerLogin: string): boolean {
  if (permalink.includes('?') || permalink.includes('#')) return false

  const pathname = getPermalinkPathname(permalink)
  if (!pathname) return false

  const pathSegments = pathname.split('/')
  const accountNamespace = pathSegments[1]
  const accountOwnerNamespace = accountNamespace === 'orgs' || accountNamespace === 'users'

  return (
    pathSegments.length === 5 &&
    accountOwnerNamespace &&
    pathSegments[2] === ownerLogin &&
    pathSegments[3] === 'issues' &&
    /^\d+$/.test(pathSegments[4] ?? '')
  )
}

export function getIssueReference({isAccountIssue, issue, ownerLogin, showRepository}: GetIssueReferenceParams) {
  if (!showRepository) return `#${issue.number}`
  if (isAccountIssue) return `${ownerLogin}#${issue.number}`
  return `${issue.repoNameWithOwner}#${issue.number}`
}

export function getLinkedPullRequestReference(
  pullRequest: Pick<IssueLinkedPullRequestSummary, 'number' | 'repoNameWithOwner'>,
) {
  if (pullRequest.number == null) return pullRequest.repoNameWithOwner ?? 'Pull request'
  return pullRequest.repoNameWithOwner
    ? `${pullRequest.repoNameWithOwner}#${pullRequest.number}`
    : `#${pullRequest.number}`
}
